Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Portal=function(_React$Component){_inherits(Portal,_React$Component);










function Portal(props){_classCallCheck(this,Portal);var _this=_possibleConstructorReturn(this,(Portal.__proto__||Object.getPrototypeOf(Portal)).call(this,
props));
_this.map={};
_this.index=1;
_this.portalUpdate=_this.portalUpdate.bind(_this);
_this.portalRegister=_this.portalRegister.bind(_this);
_this.portalDeregister=_this.portalDeregister.bind(_this);return _this;
}_createClass(Portal,[{key:"portalRegister",value:function portalRegister()

{
return++this.index;
}},{key:"portalUpdate",value:function portalUpdate(

key,element){
this.map[key]=element;
this.forceUpdate();
}},{key:"portalDeregister",value:function portalDeregister(

key){
delete this.map[key];
}},{key:"render",value:function render()


{var _this2=this;
return _react2.default.cloneElement(
this.props.groupComponent,
{},
Object.keys(this.map).map(function(key){
var el=_this2.map[key];
return el?_react2.default.cloneElement(el,{key:key}):el;
}));

}}]);return Portal;}(_react2.default.Component);Portal.displayName="Portal";Portal.propTypes={groupComponent:_react.PropTypes.element};Portal.defaultProps={groupComponent:_react2.default.createElement("g",null)};exports.default=Portal;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-portal/portal.js
// module id = 686
// module chunks = 0